// import { useEffect, useState } from 'react'
// import moment from 'moment'

const useLastUpdate = () => {
  const updated_date = 'October 29, 2026'

  return {
    updated_date,
  }
}

export default useLastUpdate
